import { FC, useRef } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import Block from "src/components/BlockList/Block";
import ValidationsBlockList from "src/components/BlockList/ValidationsBlockList";
import useBoolean from "src/hooks/useBoolean";
import useOutsideClick from "src/hooks/useOutsideClick"

interface BlockListProps {}

const BlockList: FC<BlockListProps> = () => {
  const classes = useStyles();
  const [isMenuOpen, openMenu, closeMenu] = useBoolean();

  const onElementClick = (event: MouseEvent) => {
    openMenu()
  }

  const wrapperRef = useRef(null);

  useOutsideClick(wrapperRef, closeMenu);

  return (
    <div className={classes.root}>
      <div className={classes.blocklist}>
        <Block blockType="simple" />
        <Block blockType="multiple" />
        {/* TODO: implement recursive block */}
        {/*<Block label="Bloque Recursivo" />*/}
        <Block blockType="background_check"/>
        <div className={classes.container} ref={wrapperRef}>
          <Block blockType="" draggable={false} label="Validación de Identidad" openMenu={onElementClick} open={isMenuOpen}/>
          { isMenuOpen && <ValidationsBlockList/> }
        </div>
        <Block blockType="finish" />
      </div>
      <Typography className={classes.justifyEnd}>
        última actualización
      </Typography>
      {/* TODO: add current date and loading icon when saving changes */}
      <Typography className={classes.justifyEnd}>Jun 04. 18:39</Typography>
    </div>
  );
};

BlockList.defaultProps = {};

export default BlockList;

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "grid",
    gridTemplateColumns: "3fr 1fr",
    gridTemplateRows: "1fr 1fr",
    margin: "0 38px 0 68px",
  },
  blocklist: {
    gridRow: "1 / span 2",
    display: "flex",
    justifyContent: "start",
  },
  justifyEnd: {
    justifySelf: "end",
  },
  container: {
    position: "relative",
  },
}));
